import React from "react";
import { useCallback, useRef, useState, useEffect } from "react";
import { useSocket } from "../context/SocketContext";
import UserProfileGate from "../components/common/UserProfileGate";

type GateResponse = {
  fullName?: string;
  isEmailVerified: boolean;
  email?: string;
};

export function useUserProfileGate() {
  const { socket } = useSocket();
  const resolverRef = useRef<((allowed: boolean) => void) | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState<string | null>(null);

  const cleanup = () => {
    setIsOpen(false);
  };

  const allowGate = () => {
    cleanup();
    resolverRef.current?.(true);
    resolverRef.current = null;
  };

  const closeGate = () => {
    cleanup();
    resolverRef.current?.(false);
    resolverRef.current = null;
  };

  const gate = useCallback((): boolean => {
    return true;
    // if (!socket) return Promise.resolve(false);

    // return new Promise<boolean>((resolve) => {
    //   resolverRef.current = resolve;

    //   const handler = (response: GateResponse) => {
    //     debugger;
    //     if (!response.isEmailVerified && !response.email) {
    //       setIsOpen(true);
    //     } else if (!response.isEmailVerified && response.email) {
    //       setEmail(response.email);
    //       setIsOpen(true);
    //     } else {
    //       allowGate();
    //     }
    //   };

    //   socket.once("user-profile", handler);
    //   socket.emit("user-profile");
    // });
  }, [socket]);

  useEffect(() => {
    return () => {
      socket?.off("user-profile");
    };
  }, [socket]);

  const modal = (
    <UserProfileGate
      isOpen={isOpen}
      onClose={closeGate}
      onAllow={allowGate}
      alreadySavedEmail={email}
    />
  );

  return { gate, modal };
}
